<template>
    <SwipeContainer
        title="Press the swap button"
        subtext="And get other recommendations"
        type="swap" />
</template>

<script>
    import SwipeContainer from './swipe-container.vue';

    export default {
        components: {
            SwipeContainer
        }
    };
</script>
